import React, { useContext } from 'react';
import { RelativeDateOffset } from 'nekst-api';

export interface VerifyDataUpdateService {
  updateName: (name: string) => Promise<void>;
  updateStringFieldValue: (fieldId: number, value?: string) => Promise<void>;
  updateDateFieldValue: (fieldId: number, value?: Date) => Promise<void>;
  updateNumberFieldValue: (fieldId: number, value?: number) => Promise<void>;
  updateRelativeDateOffsetValue: (fieldId: number, value?: RelativeDateOffset) => Promise<void>;
}

const VerifyDataUpdateServiceReactContext = React.createContext<VerifyDataUpdateService | null>(null);

export function useVerifyDataUpdateService(): VerifyDataUpdateService {
  const context = useContext(VerifyDataUpdateServiceReactContext);
  if (!context) {
    throw new Error('useVerifyDataUpdateService must be used within a VerifyDataUpdateServiceProvider');
  }
  return context;
}

export function VerifyDataUpdateServiceProvider(props: {
  value: VerifyDataUpdateService;
  children: React.ReactNode;
}) {
  return (
    <VerifyDataUpdateServiceReactContext.Provider value={props.value}>
      {props.children}
    </VerifyDataUpdateServiceReactContext.Provider>
  );
}
